<div class="py-3">
  <div 
    *ngFor="let message of parsedMessages trackBy: trackByMessageId"
    class="chat-message p-3 mb-3 rounded shadow-sm"
    [ngClass]="{
      'user-input': message.role === 'user',
      'assistant-reply': message.role === 'assistant'
    }"
  >
    <!-- Message Role -->
    <span
      class="message-role"
      [attr.title]="
        message.role === 'assistant' && message.additional_content?.ai_model?.length
          ? message.additional_content.ai_model[0]
          : null
      "
    >
      {{ message.role === 'user' ? 'You:' : 'SWIRL:' }}
    </span>

    <!-- Message Content -->
    <div class="mt-2">
      <span class="d-block" [innerHTML]="message.content"></span>

      <!-- Sources -->
      <ng-container *ngIf="message.additional_content?.sources?.length">
        <div class="sources-list">
          <p class="sources-header">Sources:</p>
          <ul class="sources-list-ul"
              [class.has2]="message.additional_content.sources.length >= 2">
            <li *ngFor="let source of message.additional_content.sources" class="sources-list-li">
              <!-- Favicon -->
              <img 
                [src]="getFaviconUrl(source.url)" 
                [alt]="'Favicon for ' + source.url" 
                class="source-favicon"
                (error)="handleFaviconError($event)" 
              >
              <!-- Source Link -->
              <a 
                [href]="source.url" 
                target="_blank"
                class="sources-list-link"
              >
                <span class="me-2">{{ source.title }}</span>
              </a>
            </li>
          </ul>
        </div>
      </ng-container>

      <!-- AI Model Information -->
      <ng-container 
        *ngIf="
          message.role === 'assistant' &&
          message.additional_content?.ai_model?.length > 0 &&
          message.time > 0
        "
      >
        <div class="mt-2">
          <span class="ai-chat-metadata">
            AI Summary generated 
            {{ message.additional_content?.ai_model[0] 
              ? "by " + message.additional_content?.ai_model[0] : "" }}
            in {{ message.time | number: '1.2-2' }} seconds.
          </span>
        </div>
      </ng-container>

      <!-- Rating buttons (only if not yet rated) -->
      <div class="rating-container mb-3" *ngIf="
      ragRatingEnabled
      && message.role === 'assistant'
      && message.additional_content?.ai_model?.length > 0
      && message.time > 0
      && !message.rated">
          <button class="btn-icon thumbs-up"
                  (click)="onThumbsUp(message)"
                  [disabled]="message.rated || message.show_feedback_box">
              <img [src]="message.rating === 1 ? thumbsUpActiveIcon : thumbsUpIcon" alt="Thumbs Up">
          </button>
          <button class="btn-icon thumbs-down"
                  (click)="onThumbsDown(message)"
                  [disabled]="message.rated || message.show_feedback_box">
              <img [src]="message.rating === 0 ? thumbsDownActiveIcon : thumbsDownIcon" alt="Thumbs Down">
          </button>
      </div>

      <!-- Feedback box and suggestions -->
      <div #feedbackOptions *ngIf="!message.rated && message.show_feedback_box" class="feedback-options mb-3">
          <p class="feedback-prompt">How would you qualify this answer?</p>
          <!-- Suggestion buttons: auto-submit on click -->
          <div class="suggestions">
              <button
                      *ngFor="let s of suggestions"
                      class="suggestion-btn"
                      (click)="submitFeedback(message, s)">
                  {{ s }}
              </button>
              <!-- “Other” triggers the modal -->
              <button
                      class="suggestion-btn"
                      (click)="openOtherModal(message)">
                  Other
              </button>
          </div>
      </div>
      <div class="modal fade" [ngClass]="{ 'show d-block': message.show_other_modal}"
           tabindex="-1"
           role="dialog"
           (click)="closeOtherModal(message)">
          <div class="modal-dialog" role="document" (click)="$event.stopPropagation()">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title">Provide additional feedback</h5>
                      <button
                              type="button"
                              class="btn-close"
                              (click)="closeOtherModal(message)">
                      </button>
                  </div>
                  <div class="modal-body">
                      <textarea
                              [(ngModel)]="message.feedback_text"
                              class="form-control"
                              rows="4"
                              placeholder="Type your feedback…">
                      </textarea>
                  </div>
                  <div class="modal-footer">
                      <button
                              type="button"
                              class="btn btn-secondary"
                              (click)="closeOtherModal(message)">
                          Cancel
                      </button>
                      <button
                              type="button"
                              class="btn btn-primary"
                              [disabled]="!message.feedback_text?.trim()"
                              (click)="submitFeedback(message, message.feedback_text); closeOtherModal(message)">
                          Submit
                      </button>
                  </div>
              </div>
          </div>
      </div>

      <!-- Thanks banner -->
      <div #thanksBanner class="alert alert-success text-center" *ngIf="message.show_thanks_message">
          Thanks for your feedback!
      </div>
    </div>
  </div>

  <!-- Dummy Element for Auto-Scroll -->
  <div #dummy></div>
</div>
